import React, { useEffect } from 'react';
import { Utensils, Sparkles, Leaf, Smile, TrendingUp, Shield } from 'lucide-react';
import UseCaseTemplate from '../../components/UseCaseTemplate';

const HERO_IMG = 'https://images.unsplash.com/photo-1538333581680-29dd4752ddf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc4MjY0NTgzfDA&ixlib=rb-4.1.0&q=85';

const HotelsRestaurantsCafes = () => {
  useEffect(() => {
    document.title = 'Hotels, Restaurants and Cafes | Where It’s Used | Magomeal';
  }, []);

  const benefits = [
    {
      icon: <Sparkles size={28} />,
      title: 'Premium Guest Experience',
      description: 'Surprise hotel guests, diners and cafe customers with edible serveware that turns every order into a moment.',
    },
    {
      icon: <Leaf size={28} />,
      title: 'Plastic-Free Service',
      description: 'Replace disposable plastic cups and cutlery with naturally biodegradable, edible alternatives.',
    },
    {
      icon: <TrendingUp size={28} />,
      title: 'Sustainability Marketing',
      description: 'Strengthen your eco-credentials in OTA listings, menus and reviews to attract conscious travelers and guests.',
    },
    {
      icon: <Utensils size={28} />,
      title: 'Versatile Menu Fit',
      description: 'Use for breakfast buffets, dessert presentations, coffee service, room amenities and grab-and-go offers.',
    },
    {
      icon: <Shield size={28} />,
      title: 'Hygienic & Safe',
      description: 'Individually safe to eat, with clear allergen labeling and food-grade certifications.',
    },
    {
      icon: <Smile size={28} />,
      title: 'Memorable Moments',
      description: 'Guests remember and share unique experiences, driving organic word-of-mouth and repeat visits.',
    },
  ];

  return (
    <UseCaseTemplate
      eyebrow="Where It’s Used"
      title="Hotels, Restaurants and Cafes"
      subtitle="Edible solutions that elevate hospitality and reduce single-use waste."
      heroImage={HERO_IMG}
      imageAlt="Modern restaurant interior"
      intro="Modern hospitality is judged not only on service and taste, but also on sustainability. Magomeal’s edible cups and cutlery help hotels, restaurants and cafes deliver remarkable guest experiences while phasing out single-use plastics, from welcome coffees and breakfast buffets to dessert presentations and room service. The result is a stronger brand, better reviews and a measurable step toward your sustainability goals."
      benefitsTitle="Hospitality benefits at a glance"
      benefitsSubtitle="Designed to fit seamlessly into your service flow."
      benefits={benefits}
      ctaTitle="Bring edible serveware to your venue"
      ctaText="Get menu recommendations and bulk pricing tailored to your hotel, restaurant or cafe."
      primaryCta={{ label: 'Request Pricing', to: '/contact' }}
      secondaryCta={{ label: 'View Catalog', to: '/shop' }}
    />
  );
};

export default HotelsRestaurantsCafes;
